import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  fieldGroup: {
    padding: theme.spacing(2),
  },
  cardNovoVestigio: {
    width: '100%',
    margin: theme.spacing(2, 0),
    backgroundColor: theme.palette.backGroundItem?.card || theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '8px',
    boxShadow: 'none',
    overflow: 'hidden',
  },
  cardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5, 2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  cardBody: {
    padding: theme.spacing(2.5),
  },
  embalagemContainer: {
    backgroundColor: theme.palette.backGroundItem?.cardInterno || 'rgba(0, 0, 0, 0.01)',
    padding: theme.spacing(2),
    borderRadius: '6px',
    border: `1px solid ${theme.palette.divider}`,
    width: '100%',
  },
  radioGroupHorizontal: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px',
  },
  dividerTitle: {
    marginBottom: theme.spacing(2),
  },
  dadoEspelho: {
    fontSize: '13px',
  },
  tipoVestigio: {
    width: '100%',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '12px',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  deleteGroup: {
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  }
}))

export default useStyles
